import { useEffect } from "react";
import { Button, Card, Col, Form, Input, Row, Select, Space } from "antd";
import { SearchOutlined, SendOutlined } from "@ant-design/icons";
import { t } from "i18next";
import { useDataGrid } from "../../core/components/data-grid/DataGridContext";
import { useModal } from "../../core/context/ModalContext";
import SendTestSmsModal from "./SendTestSmsModal";

export default function SmsLogFilter() {
    const { onFilterPageSort, queryModel, refreshDataGrid } = useDataGrid();
    const [form] = Form.useForm();
    const { openModal, closeModal } = useModal();

    useEffect(() => {
        form.setFieldsValue(queryModel.filter)
    }, [queryModel.updateKey])

    const onFinish = (formData) => {
        onFilterPageSort({ filter: formData })
    }

    const openTestSms = () => {
        openModal(
            t('Send Test SMS'),
            <SendTestSmsModal onSuccess={() => { closeModal(); refreshDataGrid(); }} />,
            () => { }
        )
    }

    return (
        <Card size="small" style={{ marginBottom: 16, backgroundColor: '#fdfdfd' }}>
            <Form form={form} size={'middle'} layout={'vertical'} onFinish={onFinish}>
                <Row gutter={[16, 16]} align="bottom">
                    <Col xs={24} sm={12} md={6}>
                        <Form.Item name={'phoneNumber'} label={t('Phone')} style={{ marginBottom: 0 }}>
                            <Input placeholder={t('Phone')} allowClear />
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={6}>
                        <Form.Item name={'message'} label={t('Message')} style={{ marginBottom: 0 }}>
                            <Input placeholder={t('Message')} allowClear />
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={4}>
                        <Form.Item name={'success'} label={t('Status')} style={{ marginBottom: 0 }}>
                            <Select allowClear placeholder={t('All')}>
                                <Select.Option value={true}>{t('Sent')}</Select.Option>
                                <Select.Option value={false}>{t('Failed')}</Select.Option>
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={8}>
                        <Form.Item style={{ marginBottom: 0 }}>
                            <Space>
                                <Button type="primary" htmlType={'submit'} icon={<SearchOutlined />}>
                                    {t('Search')}
                                </Button>
                                <Button icon={<SendOutlined />} onClick={openTestSms}>
                                    {t('Send Test SMS')}
                                </Button>
                            </Space>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Card>
    )
}
